import { gql } from '@apollo/client'

export const FREE_BUNDLE = gql`
  mutation freeBundle($id: ID!) {
    freeBundle(input: { id: $id }) {
      bundle {
        id
        bundleSchedules {
          status
          audience
          startDate
          endDate
          consumedAt
          freedAt
        }
      }
      errors
    }
  }
`
